import React from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../../redux/configureStore';
import { setAgencyDebt } from '../../../../../../../../../redux/fetchActions/legadoPage/transferApp';
import Wrapper from '../../../../../../../../../shared/components/Wrapper';

function SetAgencyDeb() {
  const transfersFilterState = useSelector(
    (reducer: IReducer) => reducer.transfersFilterApp
  );
  const dispatch = useDispatch();
  function setAgency(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    const onlyDigit = value.replace(/\D/g, '');
    if (onlyDigit.length > 4) {
      dispatch(setAgencyDebt(onlyDigit.slice(0, 4)));
    } else {
      dispatch(setAgencyDebt(onlyDigit));
    }
  }

  return (
    <Wrapper.Default
      width="25%"
      style={{ padding: '0 15px 5px' }}
      isActive
      flexDirection="column"
      alignItens="start">
      <span
        style={{ paddingBottom: '5px', fontWeight: 700, lineHeight: '16px' }}>
        Agência:
      </span>
      <Form.Control
        type="text"
        value={transfersFilterState.debt.agency}
        onChange={(event) => setAgency(event)}
      />
    </Wrapper.Default>
  );
}

export default SetAgencyDeb;
